import React, { useEffect, useMemo, useRef } from 'react';
import { observer } from 'mobx-react';
import Color from '@/tool/color';
import { init } from 'echarts';
import { isEmpty, isNumber, round } from 'lodash';
import moDemandPdf from '../store';
import moIndex from '../../store';

interface IProps {}
interface IState {}

const CompanyChart = (props: IProps, state: IState) => {
  let chart: any = null;
  const companyRef = useRef<any>(null);
  const colorList = [Color.primary, Color.cf, Color.secondary];
  const { isMock } = moIndex;
  const { companyIndsutryListTime } = moDemandPdf;

  const getCompanyChart = useMemo(() => {
    const xData: any = [];
    const max: any = [];
    const mid: any = [];
    const min: any = [];
    if (!isEmpty(companyIndsutryListTime)) {
      companyIndsutryListTime.forEach((res: any) => {
        xData.push(res.time_str);
        max.push(round(res.increase_ratio * 100, 2));
        mid.push(round(res.unchange_ratio * 100, 2));
        min.push(round(res.decrease_ratio * 100, 2));
      });
    }
    return { xData, max, mid, min };
  }, [companyIndsutryListTime]);

  const render = () => {
    if (chart) chart.dispose();
    chart = init(companyRef.current);
    const option = {
      color: colorList,
      legend: {
        data: ['扩招公司占比', '平招公司占比', '缩招公司占比'],
        bottom: 10,
        icon: 'roundRect',
        selectedMode: false,
        itemWidth: 8,
        itemHeight: 8,
        textStyle: {
          color: Color.c87,
          fontSize: 12,
        },
      },
      grid: {
        left: 10,
        right: 10,
        bottom: 40,
        top: 30,
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: getCompanyChart.xData,
        axisTick: { show: false },
        axisLine: {
          lineStyle: { color: Color.ccc },
        },
        axisLabel: {
          color: Color.blackColor(0.85),
          fontFamily: 'Roboto',
          fontSize: 10,
        },
      },
      yAxis: [
        {
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: { color: Color.ccc },
          },
          axisTick: { show: false },
          axisLabel: {
            show: true,
            formatter: (val: number) => {
              if (val === 0) return 0;
              return `${Number(val).toLocaleString()}`;
            },
            fontSize: 12,
            color: Color.blackColor(0.5),
            fontFamily: 'Roboto',
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: Color.blackColor(0.08),
              width: 1,
              type: 'dashed',
            },
          },
        },
      ],
      series: [
        {
          name: '扩招公司占比',
          type: 'bar',
          barWidth: 20,
          stack: 'Total',
          data: getCompanyChart.max,
          itemStyle: {
            borderWidth: 0,
          },
        },
        {
          name: '平招公司占比',
          type: 'bar',
          stack: 'Total',
          barWidth: 20,
          data: getCompanyChart.mid,
        },
        {
          name: '缩招公司占比',
          type: 'bar',
          stack: 'Total',
          barWidth: 20,
          data: getCompanyChart.min,
        },
      ],
    };
    chart.setOption(option, true);
  };
  useEffect(() => {
    render();
    window.addEventListener('resize', render);
    return () => {
      window.removeEventListener('resize', render);
    };
  }, [getCompanyChart]);

  return (
    <section
      className="company-svg-warp">
      <section
        className="company-svg"
        ref={companyRef}
        style={{
          backgroundImage: isMock ?
            'url(https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png)' :
            '',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
        }}></section>
    </section>
  );
};

export default observer(CompanyChart);
